import { render, staticRenderFns } from "./DeviceStatistics.vue?vue&type=template&id=298465a3&"
import script from "./DeviceStatistics.vue?vue&type=script&lang=js&"
export * from "./DeviceStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports